export const getDefaultFlushConfig = () => ({
    flushIntervalMs: 5000,
    maxQueueSize: 500,
    flushOnFull: false,
});
//# sourceMappingURL=utils.js.map